import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminConsultings = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONSULTINGS.GET_ALL, { params });
    return response.data;
};
export const getAdminConsultingById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONSULTINGS.GET_BY_ID(id));
    return response.data;
};
export const createConsulting = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CONSULTINGS.CREATE, data);
    return response.data;
};
export const updateConsulting = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CONSULTINGS.UPDATE(id), data);
    return response.data;
};
export const deleteConsulting = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CONSULTINGS.DELETE(id));
    return response.data;
};

